import apiClient from '@/services/axios'

export async function get(venuePortalId) {
  var params = { 'venue-portal-id': venuePortalId }

  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-details', { params: params })
  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get venue details')
}
